module.exports = __webpack_public_path__ + "static/Direct-To-Consumer-30a6e293d643006fa36087610eb1a594.jpg";